import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from './routes/router';
import { useWebSocket } from './infrastructure/websocket/useWebSocket';
import { setupTokenRefreshTimer } from './infrastructure/api/http-client';
import { useAuthStore } from './application/stores/auth.store';

export default function App() {
  useWebSocket();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const cleanup = setupTokenRefreshTimer();
    return cleanup;
  }, [isAuthenticated]);

  const element = useRoutes(routes);
  return element;
}
